import axios from "axios";
import { isExpired } from "react-jwt";
import StaticVar from "../config/StaticVar";

let isRefreshing = false;
let refreshQueue = [];

// ===> api create
const api = axios.create({
  baseURL: `${StaticVar.URL_API}/private`,
  // timeout: 100000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
  // json: true
});

const apiPublic = axios.create({
  baseURL: `${StaticVar.URL_API}`,
});

const apiMembership = axios.create({
  baseURL: `${StaticVar.URL_API}/member/private`,
  // timeout: 100000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
  // json: true
});

const apiMembershipPublic = axios.create({
  baseURL: `${StaticVar.URL_API}/member`,
});

const removeTokensFromLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};

// ===> api interceptors
api.interceptors.request.use(
  async (config) => {
    // get token
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    // check if token exists
    if (refreshToken && accessToken) {
      const accessTokenIsExpired = isExpired(accessToken);
      const refreshTokenIsExpired = isExpired(refreshToken);

      // check refresh token expire
      if (refreshTokenIsExpired) {
        // navigate to login page
        removeTokensFromLocalStorage();
        console.log("To login page");
        window.location.href = "/login?expired";

        return;
      } else {
        // check access token expire
        if (accessTokenIsExpired) {
          // if access token has expired and we're not alredy refreshing
          if (!isRefreshing) {
            isRefreshing = true;
            // send refresh token api
            try {
              const data = { refreshToken };
              // console.log("data", data);
              const refresh = await axios.post(
                `${StaticVar.URL_API}/auth/refresh`,
                data
              );
              const newAccesToken = refresh.data.accessToken;
              const newRefreshToken = refresh.data.refreshToken;

              // udpate tokens
              localStorage.setItem("access_token", newAccesToken);
              localStorage.setItem("refresh_token", newRefreshToken);

              // Call all the requests that were waiting for the access token refresh
              refreshQueue.forEach((cb) => cb(newAccesToken));
              refreshQueue = [];
              isRefreshing = false;
              console.log("succes refresh token");
            } catch (error) {
              isRefreshing = false;
              // console.log("error refresh", error);
              removeTokensFromLocalStorage();
              window.location.href = "/login?expired";
              throw new Error("Failed to refresh token");
            }
          }

          return new Promise((resolve) => {
            refreshQueue.push((token) => {
              config.headers.Authorization = `Bearer ${token}`;
              resolve(config);
            });
          });
        }

        // If the access token has not expired, set the Authorization header
        // config.headers.Authorization = `Bearer ${accessToken}`;
        // config.headers["x-access-token"] = accessToken;
        config.headers.Authorization = `Bearer ${localStorage.getItem(
          "access_token"
        )}`;
      }
    }

    // console.log("return config");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if error.response exists before accessing it
    if (error.response) {
      console.log("err response", error.response);
      if (error.response.status === 401) {
        console.log("err 401 Unauthorized");
        // removeTokensFromLocalStorage();
        // window.location.href = '/login?expired';
        return;
      }
    } else {
      // Handle network errors where no response is received
      console.log("Network error or server not responding:", error.message);
    }
    return Promise.reject(error);
  }
);

// api routes
// auth
const verifySignInRole = data => apiPublic.post(`/auth/role/verify`, data)
const postRegister = data =>
  apiPublic.post(`/auth/register`, data)
const postLogin = data =>
  apiPublic.post(`/auth/login`, data)
// sidebar
const getSidebar = (id, params) => api.get(`/role/menu/${id}`, { params })
const switchRole = (data) =>
  apiPublic.post("/auth/switch-role", data);

// user
const getAllUser = (params) => api.get("/user", { params });
const getUser = (id, params) => api.get(`/user/${id}`, { params });
const postUser = (data) => api.post("/user", data);
const putUser = (id, data) => api.put(`/user/${id}`, data);
const deleteUser = (id) => api.delete(`/user/${id}`);

// Chapter
const getPublicChapter = (params) => apiMembershipPublic.get("/chapter", { params });
const getAllChapter = (params) => apiMembership.get("/chapter", { params });
const postChapter = (data) => apiMembership.post("/chapter", data);
const putChapter = (id, data) => apiMembership.put(`/chapter/${id}`, data);
const deleteChapter = (id) => apiMembership.delete(`/chapter/${id}`);

// Membership
const getMembership = (params) => apiMembership.get("/membership", { params });
const getMembershipByStatus = (status, params) =>
  apiMembership.get(`/membership/status/${status}`, { params });
const getMembershipById = (id, params) =>
  apiMembership.get(`/membership/${id}`, { params });
const postMembership = (data) => apiMembershipPublic.post("/membership", data);
const putMembership = (id, data) => apiMembership.put(`/membership/${id}`, data);
const verificateMembership = (id, data) =>
  apiMembership.put(`/membership/verificate/${id}`, data);
const deleteMembership = (id) => apiMembership.delete(`/membership/${id}`);

// Organizational Unit
const getAllOrganizationalUnit = (params) =>
  api.get("/organizational-unit", { params });
const getOrganizationalUnit = (id, params) =>
  api.get(`/organizational-unit/${id}`, { params });
const postOrganizationalUnit = (data) =>
  api.post("/organizational-unit", data);
const putOrganizationalUnit = (id, data) =>
  api.put(`/organizational-unit/${id}`, data);
const deleteOrganizationalUnit = (id) =>
  api.delete(`/organizational-unit/${id}`);

// Master Data
const getAllFAQ = (params) => api.get("/faq", { params });
const getFAQ = (id, params) => api.get(`/faq/${id}`, { params });
const postFAQ = (data) => api.post("/faq", data);
const putFAQ = (id, data) => api.put(`/faq/${id}`, data);
const deleteFAQ = (id) => api.delete(`/faq/${id}`);

const getAllEvent = (params) => api.get("/event", { params });
const getEvent = (id, params) => api.get(`/event/${id}`, { params });
const postEvent = (data) => api.post("/event", data);
const putEvent = (id, data) => api.put(`/event/${id}`, data);
const deleteEvent = (id) => api.delete(`/event/${id}`);
const uploadImageEvent = (data, callback) =>
  api.post("/event/upload", data, { onUploadProgress: callback });
const getEventCategories = (params) => api.get("/event/category", { params });
const postEventCategory = (data) => api.post("/event/category", data);
const deleteEventCategory = (id) => api.delete(`/event/category/${id}`);

const getAllSponsor = (params) => api.get("/sponsor", { params });
const getSponsor = (id, params) => api.get(`/sponsor/${id}`, { params });
const postSponsor = (data) => api.post("/sponsor", data);
const putSponsor = (id, data) => api.put(`/sponsor/${id}`, data);
const deleteSponsor = (id) => api.delete(`/sponsor/${id}`);

const getAllSurveyQuestion = (params) =>
  api.get("/survey/question", { params });
const getSurveyQuestion = (id, params) =>
  api.get(`/survey/question/${id}`, { params });
const postSurveyQuestion = (data) => api.post("/survey/question", data);
const putSurveyQuestion = (id, data) => api.put(`/survey/question/${id}`, data);
const deleteSurveyQuestion = (id) => api.delete(`/survey/question/${id}`);

// Survey
const getAllSurvey = (params) => api.get("/survey", { params });
const getSurvey = (id, params) => api.get(`/survey/${id}`, { params });

// Banner Slider
const getAllBanner = (params) => api.get("/banner", { params });
const getBanner = (id, params) => api.get(`/banner/${id}`, { params });
const postBanner = (data) => api.post("/banner", data);
const putBanner = (id, data) => api.put(`/banner/${id}`, data);
const deleteBanner = (id) => api.delete(`/banner/${id}`);
const uploadBanner = (data, callback) =>
  api.post("/banner/upload", data, { onUploadProgress: callback });

// Popup
const getPopups = (params) => api.get("/popup", { params });
const getPopup = (id, params) => api.get(`/popup/${id}`, { params });
const postPopup = (data) => api.post("/popup", data);
const putPopup = (id, data) => api.put(`/popup/${id}`, data);
const deletePopup = (id) => api.delete(`/popup/${id}`);
const uploadPopup = (data, callback) =>
  api.post("/popup/upload", data, { onUploadProgress: callback });

// Gallery
const getAllPhoto = (params) => api.get("/photo", { params });
const getPhoto = (id, params) => api.get(`/photo/${id}`, { params });
const postPhoto = (data) => api.post("/photo", data);
const postMultiPhoto = (data) => api.post("/photo/multi", data);
const putPhoto = (id, data) => api.put(`/photo/${id}`, data);
const deletePhoto = (id) => api.delete(`/photo/${id}`);
const uploadPhoto = (data, callback) =>
  api.post("/photo/upload", data, { onUploadProgress: callback });

const getAllVideo = (params) => api.get("/video", { params });
const getVideo = (id, params) => api.get(`/video/${id}`, { params });
const postVideo = (data) => api.post("/video", data);
const putVideo = (id, data) => api.put(`/video/${id}`, data);
const deleteVideo = (id) => api.delete(`/video/${id}`);
const uploadVideoThumbnail = (data, callback) =>
  api.post("/video/upload", data, { onUploadProgress: callback });

// Sitemap
const getAllSitemap = (params) => api.get("/sitemap", { params });
const getUnstructuredSitemaps = (params) =>
  api.get("/sitemap/unstructured", { params });
const getSitemap = (id, params) => api.get(`/sitemap/${id}`, { params });
const postSitemap = (data) => api.post("/sitemap", data);
const putSitemap = (id, data) => api.put(`/sitemap/${id}`, data);
const deleteSitemap = (id) => api.delete(`/sitemap/${id}`);

// Pages
const getStructuredNestedPage = (params) =>
  api.get("/page/structured", { params });
const getAllPage = (params) => api.get("/page", { params });
const getPage = (id, params) => api.get(`/page/${id}`, { params });
const postPage = (data) => api.post("/page", data);
const putPage = (id, data) => api.put(`/page/${id}`, data);
const deletePage = (id) => api.delete(`/page/${id}`);
const uploadPage = (data, callback) =>
  api.post("/page/upload", data, { onUploadProgress: callback });

// Organization
const getAllOrganization = (params) => api.get("/organization", { params });
const getOrganization = (id, params) =>
  api.get(`/organization/${id}`, { params });
const postOrganization = (data) => api.post("/organization", data);
const putOrganization = (id, data) => api.put(`/organization/${id}`, data);
const deleteOrganization = (id) => api.delete(`/organization/${id}`);
const uploadOrganization = (data, callback) =>
  api.post("/organization/upload", data, { onUploadProgress: callback });

// Document
const getDocumentCategories = (params) =>
  api.get("/document/category", { params });
const getListEditorDocumentCategories = (id, params) =>
  api.get(`/document/category/editor/${id}`, { params });
const postDocumentCategory = (data) => api.post("/document/category", data);
const putDocumentCategory = (id, data) =>
  api.put(`/document/category/${id}`, data);
const putListEditorDocumentCategory = (id, data, params) =>
  api.put(`/document/category/editor/${id}`, data, { params });
const deleteDocumentCategory = (id) => api.delete(`/document/category/${id}`);

const getAllDocument = (params) => api.get("/document", { params });
const getDocument = (id, params) => api.get(`/document/${id}`, { params });
const postDocument = (data) => api.post("/document", data);
const putDocument = (id, data) => api.put(`/document/${id}`, data);
const deleteDocument = (id) => api.delete(`/document/${id}`);
const uploadDocument = (data, callback) =>
  api.post("/document/upload", data, { onUploadProgress: callback });

// contents
const getAllContent = (params) => api.get("/content", { params });
const getContent = (id, params) => api.get(`/content/${id}`, { params });
const getContentCategories = (params) =>
  api.get("/content/category", { params });
const getListEditorContentCategories = (id, params) =>
  api.get(`/content/category/editor/${id}`, { params });
const getContentCategory = (id, params) =>
  api.get(`/content/category/${id}`, { params });
const postContentCategory = (data) => api.post("/content/category", data);
const putContentCategory = (id, data) =>
  api.put(`/content/category/${id}`, data);
const putListEditorContentCategory = (id, data, params) =>
  api.put(`/content/category/editor/${id}`, data, { params });
const deleteContentCategory = (id) => api.delete(`/content/category/${id}`);
const uploadImageCategory = (data, params) =>
  api.post("/content/category/upload", data, { params });
const postContent = (data) => api.post("/content", data);
const putContent = (id, data) => api.put(`/content/${id}`, data);
const deleteContent = (id) => api.delete(`/content/${id}`);
const uploadImageContent = (data) => api.post("/content/upload", data);
const uploadVideoContent = (data, callback) =>
  api.post("/content/upload", data, { onUploadProgress: callback });
const updateStatusContent = (id, data) =>
  api.put(`/content/${id}/status`, data);

// Role
const postRole = (data) => api.post("/role", data);
const getRoleByUser = (data) => api.get(`/role/user/${data}`);
const getRoles = (params) => api.get("/role", { params });
const putRoleProfile = (id, data) => api.put(`/role/${id}`, data);
const putChangePermission = (id, data) =>
  api.put(`/role/permission/${id}`, data);
const putChangePermissionPage = (id, data) =>
  api.put(`/role/page-permission/${id}`, data);
const deleteRole = (id) => api.delete(`/role/${id}`);
const putHomeMenu = (id, data) => api.put(`/role/home/${id}`, data);
const getListPermissions = () => api.get("/permission");

// permissions
const getPermissions = (params) => api.get('/permission', { params });
const getPermissionsByUserId = (id, params) => api.get(`/permission/user/${id}`, { params });
const postPermission = (data) => api.post('/permission', data);
const putPermission = (id, data) => api.put(`/permission/${id}`, data);
const deletePermission = (id) => api.delete(`/permission/${id}`);

// pages
const getPagesManagement = (params) => api.get('/page-management', { params });
const getUnstructuredPagesManagement = (params) => api.get('/page-management/unstructured', { params });
const postPageManagement = (data) => api.post('/page-management', data);
const putPageManagement = (id, data) => api.put(`/page-management/${id}`, data);
const deletePageManagement = (id) => api.delete(`/page-management/${id}`);

// Data Area
const getDataArea = (params) => api.get("/area", { params });

// Dashboard
const getDashboardContent = (params) =>
  api.get("/content/dashboard", { params });
const getDashboardUser = (params) => api.get("/user/dashboard", { params });
const getDashboardMedical = (params) =>
  api.get("/medical/dashboard", { params });

// App Config API Functions
const getAppConfigPublic = () => apiPublic.get("/app-config");
const getAppConfig = () => api.get("/app-config");
const updateAppConfig = (id, data) => api.put(`/app-config/${id}`, data);
const uploadLogo = (formData) => api.post("/app-config/upload-logo", formData);
//footer api
const getFooter = () => api.get("/footer");
const updateFooter = (data) => api.put(`/footer`, data);

//visi misi API
const getVisiMisi = () => api.get("/visi-misi");
const postVisiMisi = (data) => api.post("/visi-misi", data);
const putVisiMisi = (id, data) => api.put(`/visi-misi/${id}`, data);

// Partner API
const getAllPartner = (params) => api.get("/partner", { params });
const getPartnerById = (id, params) => api.get(`/partner/${id}`, { params });
const getPartnerByCategory = (id, params) =>
  api.get(`/partner/getByCategory/${id}`, { params });
const postPartner = (data) => api.post("/partner", data);
const putPartner = (id, data) => api.put(`/partner/${id}`, data);
const deletePartner = (id) => api.delete(`/partner/${id}`);
const uploadImagePartner = (data, callback) =>
  api.post("/partner/upload", data, { onUploadProgress: callback });
const getPartnerCategories = (params) =>
  api.get("/partner/category", { params });
const postPartnerCategory = (data) => api.post("/partner/category", data);
const deletePartnerCategory = (id) => api.delete(`/partner/category/${id}`);

// Benefit API
const getAllBenefit = (params) => api.get("/benefit", { params });
const getBenefitById = (id, params) => api.get(`/benefit/${id}`, { params });
const postBenefit = (data) => api.post("/benefit", data);
const putBenefit = (id, data) => api.put(`/benefit/${id}`, data);
const deleteBenefit = (id) => api.delete(`/benefit/${id}`);

// Organization Structure API
const getAllOrganizationStructure = (params) =>
  api.get("/organization-structure", { params });
const getOrganizationStructureById = (id, params) =>
  api.get(`/organization-structure/${id}`, { params });
const postOrganizationStructure = (data) =>
  api.post("/organization-structure", data);
const putOrganizationStructure = (id, data) =>
  api.put(`/organization-structure/${id}`, data);
const deleteOrganizationStructure = (id) =>
  api.delete(`/organization-structure/${id}`);
const uploadOrganizationStructureImage = (data, callback) =>
  api.post("/organization-structure/upload", data, {
    onUploadProgress: callback,
  });
const getOrganizationStructureCategories = (params) =>
  api.get("/organization-structure/category", { params });
const postOrganizationStructureCategory = (data) =>
  api.post("/organization-structure/category", data);
const putOrganizationStructureCategory = (id, data) =>
  api.put(`/organization-structure/category/${id}`, data);
const deleteOrganizationStructureCategory = (id) =>
  api.delete(`/organization-structure/category/${id}`);

const getAllUnitTasks = (params) =>
  api.get("/unit-tasks", { params });
const postUnitTasks = (data) =>
  api.post("/unit-tasks", data);
const putUnitTasks = (id, data) =>
  api.put(`/unit-tasks/${id}`, data);
const deleteUnitTasks = (id) =>
  api.delete(`/unit-tasks/${id}`);
const uploadUnitTasks = (data, callback) =>
  api.post("/unit-tasks/upload", data, { onUploadProgress: callback });
const getUnitTasksByUnitId = (id, params) =>
  api.get(`/unit-tasks/unit/${id}`, { params });

const API = {
  verifySignInRole,
  postRegister,
  postLogin,
  getSidebar,
  switchRole,
  
  getAllUser,
  getUser,
  postUser,
  putUser,
  deleteUser,
  getAllContent,
  getContent,
  getPermissions,
  getPermissionsByUserId,
  postPermission,
  putPermission,
  putChangePermissionPage,
  deletePermission,
  getPagesManagement,
  getUnstructuredPagesManagement,
  postPageManagement,
  putPageManagement,
  deletePageManagement,
  

  getPublicChapter,

  getAllChapter,
  postChapter,
  putChapter,
  deleteChapter,

  getMembership,
  getMembershipByStatus,
  getMembershipById,
  postMembership,
  putMembership,
  verificateMembership,
  deleteMembership,

  getAllOrganizationalUnit,
  getOrganizationalUnit,
  postOrganizationalUnit,
  putOrganizationalUnit,
  deleteOrganizationalUnit,

  getAllUnitTasks,
  postUnitTasks,
  putUnitTasks,
  deleteUnitTasks,
  uploadUnitTasks,
  getUnitTasksByUnitId,

  getAllFAQ,
  getFAQ,
  postFAQ,
  putFAQ,
  deleteFAQ,

  getAllEvent,
  getEvent,
  postEvent,
  putEvent,
  deleteEvent,
  uploadImageEvent,
  getEventCategories,
  postEventCategory,
  deleteEventCategory,

  getAllSponsor,
  getSponsor,
  postSponsor,
  putSponsor,
  deleteSponsor,

  getAllSurveyQuestion,
  getSurveyQuestion,
  postSurveyQuestion,
  putSurveyQuestion,
  deleteSurveyQuestion,

  getAllVideo,
  getVideo,
  postVideo,
  putVideo,
  deleteVideo,
  uploadVideoThumbnail,

  getAllBanner,
  getBanner,
  postBanner,
  putBanner,
  deleteBanner,
  uploadBanner,

  getAllPage,
  getStructuredNestedPage,
  getPage,
  postPage,
  putPage,
  deletePage,
  uploadPage,

  getDocumentCategories,
  getListEditorDocumentCategories,
  postDocumentCategory,
  putDocumentCategory,
  putListEditorDocumentCategory,
  deleteDocumentCategory,

  getAllDocument,
  getDocument,
  postDocument,
  putDocument,
  deleteDocument,
  uploadDocument,

  getAllOrganization,
  getOrganization,
  postOrganization,
  putOrganization,
  deleteOrganization,
  uploadOrganization,

  getAllSitemap,
  getUnstructuredSitemaps,
  getSitemap,
  postSitemap,
  putSitemap,
  deleteSitemap,

  getAllPhoto,
  getPhoto,
  postPhoto,
  postMultiPhoto,
  putPhoto,
  deletePhoto,
  uploadPhoto,

  getAllSurvey,
  getSurvey,

  getPopups,
  getPopup,
  postPopup,
  putPopup,
  deletePopup,
  uploadPopup,

  postContent,
  putContent,
  deleteContent,
  uploadImageContent,
  uploadVideoContent,
  getContentCategories,
  getContentCategory,
  postContentCategory,
  putContentCategory,
  deleteContentCategory,
  uploadImageCategory,
  getListEditorContentCategories,
  putListEditorContentCategory,
  updateStatusContent,

  getRoleByUser,
  postRole,
  getRoles,
  putRoleProfile,
  putChangePermission,
  deleteRole,
  getListPermissions,

  getDataArea,

  getDashboardContent,
  getDashboardUser,
  getDashboardMedical,

  getAppConfigPublic,
  getAppConfig,
  updateAppConfig,
  uploadLogo,

  getFooter,
  updateFooter,

  getVisiMisi,
  postVisiMisi,
  putVisiMisi,

  getAllPartner,
  getPartnerById,
  postPartner,
  putPartner,
  deletePartner,
  uploadImagePartner,
  getPartnerCategories,
  postPartnerCategory,
  deletePartnerCategory,

  getAllBenefit,
  getBenefitById,
  postBenefit,
  putBenefit,
  deleteBenefit,

  getAllOrganizationStructure,
  getOrganizationStructureById,
  postOrganizationStructure,
  putOrganizationStructure,
  deleteOrganizationStructure,
  uploadOrganizationStructureImage,
  getOrganizationStructureCategories,
  postOrganizationStructureCategory,
  putOrganizationStructureCategory,
  deleteOrganizationStructureCategory,
};

export default API;
